(function () {
  const drawer = document.getElementById("QuickAdd");
  if (!drawer) return;

  const open = () => {
    drawer.style.display = "block";
    drawer.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
  };

  const close = () => {
    drawer.style.display = "none";
    drawer.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
  };

  drawer.addEventListener("click", (e) => {
    if (e.target.matches("[data-qa-close]")) close();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") close();
  });

  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-quick-add]");
    if (!btn) return;
    open();
  });
})();
